import { Controller } from '@hotwired/stimulus';

/**
 * Card composer - quick "add card" textarea: Enter submits, Shift+Enter adds a new line, Escape cancels.
 * While open, the list's cards are scrolled to the end, where the new card lands (and shows up after a create).
 * Targets: input - the textarea | cancel - element clicked on Escape (closes the composer)
 * Values: cards-id (String) - id of the list's scrollable cards container
 * @example
 * <details data-controller="card-composer" data-card-composer-cards-id-value="board_list_7_cards" data-action="toggle->card-composer#focus">
 *   <form>
 *     <textarea data-card-composer-target="input" data-action="keydown->card-composer#keydown"></textarea>
 *     <a data-card-composer-target="cancel" href="…">Cancel</a>
 *   </form>
 * </details>
 */
export default class extends Controller {
  static targets = ['input', 'cancel'];
  static values = { cardsId: String };

  connect () {
    this.focus();
  }

  focus () {
    if (!this.element.open) return;

    const cards = document.getElementById(this.cardsIdValue);
    if (cards) cards.scrollTop = cards.scrollHeight;
    if (this.hasInputTarget) this.inputTarget.focus();
  }

  keydown (event) {
    if (event.key === 'Escape') {
      if (this.hasCancelTarget) {
        event.preventDefault();
        this.cancelTarget.click();
      }
    } else if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
      event.preventDefault();
      if (this.inputTarget.value.trim() !== '') this.inputTarget.form.requestSubmit();
    }
  }
}
